<template>
  <div id="contents" class="tagList contents">
    <products-list
      :listTypeBest="true"
      :isCartbuttonVisible="false"
      :productList="tag.productList"
    ></products-list>
  </div>
</template>

<script>
import ProductsList from '@/views/shop/ProductsList'
import { mapActions, mapGetters } from 'vuex';
import mixin from '@/utils/mixin'

export default {
  name: 'TagList',
  mixins: [mixin],
  components: {
    ProductsList,
  },
  props: {
    query: {
      type: String,
      default: ''
    }
  },
  watch: {
    bottom: {
      handler(n, o) {
        if (n) {
          this.handleAPICall()
        }
      }
    }
  },
  data() {
    return {
      bottom: false
    }
  },
  
  computed: {
    ...mapGetters('main', ['tag'])
  },
  methods: {
    ...mapActions('main', ['getProductListByTag']),
    handleScroll() {
      const { last } = this.tag
      if (last === false) {
        this.bottom = this.bottomVisible()
      } 
    },
    handleAPICall(reset) {
      this.getProductListByTag({ tagName: this.query, reset })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleAPICall(true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
</style>
